import React, { useEffect, useRef, useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from "axios";
import { baseurladdress } from "../baseurl";
import $ from "jquery";
import Select from "react-select";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Swal = require('sweetalert2');

function Jobpost() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [showModal, setShowModal] = useState(false);
    //department name
    const [departments, setDepartments] = useState([]);
    //const [dept, setDept] = useState("");
    const departmentOptions = departments.map((item) => ({
        value: item.dept_id,
        label: item.dept_name,
    }));
    //branch name
    const [branches, setBranches] = useState([]);
    const [branch, setBranch] = useState("");
    const branchOptions = branches.map((item) => ({
        value: item.branch_id,
        label: item.branch_name,
    }));
    // branch location
    const [branchPlace, setBranchPlace] = useState("");
    const today = new Date().toISOString().split("T")[0];
    const [jobs, setJobs] = useState([]);

    const brOptions = branches.map(item => ({
        value: item.branch_id,
        label: item.branch_name
    }));
    // const [errors, setErrors] = useState({});

    // const [todate, setTodate] = useState("");
    // const [fromdate, setFromdate] = useState("");
    // const [filterstatus, setfilterStatus] = useState("");
    const [search, setSearch] = useState({
        branchId: "",
        // branch: "",
        // postingDate: "",
        // closingDate: ""
    });
    // const handleSearchChange = (e) => {
    //     setSearch({
    //         ...search,
    //         [e.target.name]: e.target.value,
    //     });
    // };
    const handleSearchChange = (e) => {
        const { name, value } = e.target;

        setSearch((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const clearFilters = async () => {
        window.location.reload();
        // setSearch({
        //     branchId: "",
        //     branch_name: "",
        //     postingDate: "",
        //     closingDate: ""
        // });

        // setIsSearching(false);

        // await getJobs();
    };
    const [editshowModal, seteditShowModal] = useState(false);
    const [errors, setErrors] = useState({
        ddchr_recruitment_title: false,
        ddchr_recruitment_deptid: false,
        ddchr_recruitment_designation: false,
        ddchr_recruitment_workmode: false,
        ddchr_recruitment_employmenttype: false,
        ddchr_recruitment_vaccancies: false,
        ddchr_recruitment_workschedule: false,
        ddchr_recruitment_jointype: false,
        ddchr_recruitment_branchid: false,
        ddchr_recruitment_minexp: false,
        ddchr_recruitment_maxexp: false,
        ddchr_recruitment_unit: false,
        ddchr_recruitment_qualification: false,
        ddchr_recruitment_skills: false,
        ddchr_recruitment_description: false,
        ddchr_recruitment_summary: false,
        ddchr_recruitment_keywords: false,
        ddchr_recruitment_postingdate: false,
        ddchr_recruitment_closingdate: false,
        ddchr_recruitment_status: false,
        ddchr_recruitment_contactperson: false,
        ddchr_recruitment_contactnumber: false,
        ddchr_recruitment_contactemail: false
    });

    const departmentRef = useRef(null);
    const designationRef = useRef(null);
    const branchRef = useRef(null);
    const qualificationRef = useRef(null);

    // const [editJobTitle, setJobTitle] = useState("");
    const [Departmentid, setDepartmentid] = useState("");
    const [Departmentname, setDepartmentname] = useState("");
    const [designation, setDesignation] = useState("");
    const [jobcode, setJobcode] = useState("");
    const [isDeptChanged, setIsDeptChanged] = useState(false);
    const [isDesigChanged, setIsDesigChanged] = useState(false);
    // const [workmode, setWorkmode] = useState("");
    // const [employmenttype, setEmploymenttype] = useState("");
    // const [vaccancies, setVaccancies] = useState("");
    // const [workschedule, setWorkschedule] = useState("");
    // const [priorities, setPriorities] = useState("");
    // const [jointype, setJointype] = useState("");
    // const [branchid, setBranchid] = useState("");
    // const [branchname, setBranchname] = useState("");
    const [location, setLocation] = useState("");
    // const [minexp, setMinexp] = useState("");
    // const [maxexp, setMaxexp] = useState("");
    // const [unit, setUnit] = useState("");
    // const [salarytype, setSalarytype] = useState("");
    // const [minsal, setMinsal] = useState("");
    // const [maxsal, setMaxsal] = useState("");
    // const [incentives, setIncentives] = useState("");
    // const [specialization, setSpecialization] = useState("");
    // const [minage, setMinage] = useState("");
    // const [maxage, setMaxage] = useState("");
    // const [preferredcandidate, setPreferredcandidate] = useState("");
    // const [drivingliscence, setDrivingliscence] = useState("");
    // const [willtotravel, setwilltotravel] = useState("");
    // const [description, setDescription] = useState("");
    // const [summary, setSummary] = useState("");
    // const [benefits, setBenefits] = useState("");
    // const [keyword, setKeyword] = useState("");
    // const [postingdate, setPostingdate] = useState("");
    // const [status, setStatus] = useState("");
    // const [applicationmode, setapplicationmode] = useState("");
    // const [contactperson, setcontactperson] = useState("");
    // const [contactnumber, setcontactnumber] = useState("");
    // const [contactemail, setcontactemail] = useState("");
    // const [website, setwebsite] = useState("");
    // const [instructions, setinstructions] = useState("");
    // const [selectionprocess, setselectionprocess] = useState("");
    // const [interviewmode, setinterviewmode] = useState("");
    // const [intlocation, setintLocation] = useState("");
    // const [joindate, setjoindate] = useState("");
    // const [intinstructions, setintinstructions] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    const initialForm = {
        ddchr_recruitment_id: "",
        ddchr_recruitment_code: "",
        ddchr_recruitment_title: "",
        ddchr_recruitment_deptid: "",
        ddchr_recruitment_deptname: "",
        ddchr_recruitment_designation: "",
        ddchr_recruitment_branchid: "",
        ddchr_recruitment_branchname: "",
        ddchr_recruitment_branchaddress: "",
        ddchr_recruitment_employmenttype: "",
        ddchr_recruitment_vaccancies: "",
        ddchr_recruitment_workschedule: "",
        ddchr_recruitment_priorities: "",
        ddchr_recruitment_jointype: "",
        ddchr_recruitment_workmode: "",
        ddchr_recruitment_minexp: "",
        ddchr_recruitment_maxexp: "",
        ddchr_recruitment_unit: "",
        ddchr_recruitment_salarytype: "",
        ddchr_recruitment_minsal: "",
        ddchr_recruitment_maxsal: "",
        ddchr_recruitment_incentives: "",
        ddchr_recruitment_qualification: [],
        ddchr_recruitment_specialization: "",
        ddchr_recruitment_skills: "",
        ddchr_recruitment_langknown: "",
        ddchr_recruitment_certifications: "",
        ddchr_recruitment_minage: "",
        ddchr_recruitment_maxage: "",
        ddchr_recruitment_preferredcandidate: "",
        ddchr_recruitment_drivingliscence: "",
        ddchr_recruitment_willtotravel: "",
        ddchr_recruitment_description: "",
        ddchr_recruitment_summary: "",
        ddchr_recruitment_benefits: "",
        ddchr_recruitment_keywords: "",
        ddchr_recruitment_postingdate: today,
        ddchr_recruitment_closingdate: "",
        ddchr_recruitment_lastdate: "",
        ddchr_recruitment_status: "",
        ddchr_recruitment_applicationmode: "",
        ddchr_recruitment_contactperson: "",
        ddchr_recruitment_contactnumber: "",
        ddchr_recruitment_contactemail: "",
        ddchr_recruitment_contactwebsite: "",
        ddchr_recruitment_appinstruction: "",
        ddchr_recruitment_selectionprocess: "",
        ddchr_recruitment_interviewmode: "",
        ddchr_recruitment_interviewlocation: "",
        ddchr_recruitment_expectedjoin: "",
        ddchr_recruitment_interviewinstruction: "",
        ddchr_recruitment_ctdby: accessuserid
    };
    const [form, setForm] = useState(initialForm);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true
        });

        // Clear previous errors
        setErrors({});

        // Job Title
        if (!form.ddchr_recruitment_title.trim()) {
            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_title: true
            }));

            document.getElementsByName("ddchr_recruitment_title")[0].focus();
            return;
        }


        // Department
        if (!form.ddchr_recruitment_deptid) {
            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_deptid: true
            }));

            departmentRef.current?.focus();
            return;
        }


        //Designation
        if (!form.ddchr_recruitment_designation.trim()) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_designation: true
            }));

            document.getElementsByName("ddchr_recruitment_designation")[0].focus();

            return;
        }

        // work mode
        if (form.ddchr_recruitment_workmode === "0" || form.ddchr_recruitment_workmode === "") {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_workmode: true
            }));

            document.getElementsByName("ddchr_recruitment_workmode")[0].focus();
            return;
        }

        //Employment Type
        if (form.ddchr_recruitment_employmenttype === "0" || form.ddchr_recruitment_employmenttype === "") {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_employmenttype: true
            }));

            document.getElementsByName("ddchr_recruitment_employmenttype")[0].focus();
            return;
        }

        //Vaccancies
        if (
            !form.ddchr_recruitment_vaccancies ||
            Number(form.ddchr_recruitment_vaccancies) <= 0
        ) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_vaccancies: true
            }));

            document.getElementsByName("ddchr_recruitment_vaccancies")[0].focus();

            return;
        }

        // Work schedule
        if (!form.ddchr_recruitment_workschedule) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_workschedule: true
            }));

            document.getElementsByName("ddchr_recruitment_workschedule")[0].focus();

            return;
        }
        // Join type
        if (
            form.ddchr_recruitment_jointype === "0" ||
            form.ddchr_recruitment_jointype === ""
        ) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_jointype: true
            }));

            document.getElementsByName("ddchr_recruitment_jointype")[0].focus();

            return;
        }
        // Branch

        if (!form.ddchr_recruitment_branchid) {
            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_branchid: true
            }));

            branchRef.current?.focus();
            return;
        }

        //Minimum Experience
        if (
            !form.ddchr_recruitment_minexp ||
            Number(form.ddchr_recruitment_minexp) < 0

        ) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_minexp: true
            }));

            document.getElementsByName("ddchr_recruitment_minexp")[0].focus();

            return;
        }
        //Maximum Experience
        if (
            !form.ddchr_recruitment_maxexp ||
            Number(form.ddchr_recruitment_maxexp) < 0
        ) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_maxexp: true
            }));

            document.getElementsByName("ddchr_recruitment_maxexp")[0].focus();

            return;
        }
        //Units
        if (
            form.ddchr_recruitment_unit === "0" ||
            form.ddchr_recruitment_unit === ""
        ) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_unit: true
            }));

            document.getElementsByName("ddchr_recruitment_unit")[0].focus();

            return;
        }
        //Qualification
        if (form.ddchr_recruitment_qualification.length === 0) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_qualification: true
            }));

            qualificationRef.current?.focus();

            return;
        }
        //Required skills
        if (!form.ddchr_recruitment_skills.trim()) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_skills: true
            }));

            document.getElementsByName("ddchr_recruitment_skills")[0].focus();

            return;
        }
        //Job Description
        if (!form.ddchr_recruitment_description.trim()) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_description: true
            }));

            document.getElementsByName("ddchr_recruitment_description")[0].focus();

            return;
        }
        //Summary
        if (!form.ddchr_recruitment_summary.trim()) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_summary: true
            }));

            document.getElementsByName("ddchr_recruitment_summary")[0].focus();

            return;
        }
        //Keywords
        if (!form.ddchr_recruitment_keywords.trim()) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_keywords: true
            }));

            document.getElementsByName("ddchr_recruitment_keywords")[0].focus();

            return;
        }
        // Posting Date
        if (!form.ddchr_recruitment_postingdate) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_postingdate: true
            }));

            document.getElementsByName("ddchr_recruitment_postingdate")[0].focus();

            return;
        }

        // Closing Date
        if (!form.ddchr_recruitment_closingdate) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_closingdate: true
            }));

            document.getElementsByName("ddchr_recruitment_closingdate")[0].focus();

            return;
        }

        // Closing Date cannot be earlier than Posting Date
        if (
            new Date(form.ddchr_recruitment_closingdate) <
            new Date(form.ddchr_recruitment_postingdate)
        ) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_closingdate: true
            }));

            document.getElementsByName("ddchr_recruitment_closingdate")[0].focus();

            return;
        }

        // Job Status
        if (
            form.ddchr_recruitment_status === "" ||
            form.ddchr_recruitment_status === "0"
        ) {

            setErrors((prev) => ({
                ...prev,
                ddchr_recruitment_status: true
            }));

            document.getElementsByName("ddchr_recruitment_status")[0].focus();

            return;
        }
        // Contact Person
        if (!form.ddchr_recruitment_contactperson.trim()) {

            setErrors(prev => ({
                ...prev,
                ddchr_recruitment_contactperson: true
            }));

            document.getElementsByName("ddchr_recruitment_contactperson")[0].focus();
            return;
        }

        // Contact Number
        if (!/^[0-9]{10}$/.test(form.ddchr_recruitment_contactnumber)) {

            setErrors(prev => ({
                ...prev,
                ddchr_recruitment_contactnumber: true
            }));

            document.getElementsByName("ddchr_recruitment_contactnumber")[0].focus();
            return;
        }

        // Email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(form.ddchr_recruitment_contactemail)) {

            setErrors(prev => ({
                ...prev,
                ddchr_recruitment_contactemail: true
            }));

            document.getElementsByName("ddchr_recruitment_contactemail")[0].focus();
            return;
        }
        try {

            const token = localStorage.getItem("token");

            const saveData = {
                ...form,
                ddchr_recruitment_qualification:
                    form.ddchr_recruitment_qualification.join(",")
            };

            const res = await axios.post(
                baseurladdress + "addrecruitment",
                saveData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.data.status === "success") {

                await Toast.fire({
                    icon: "success",
                    title: "Recruitment added successfully"
                });

                // Reset form
                setForm(initialForm);

                // Clear validation
                setErrors({});

                // Close modal
                setShowModal(false);

                // Refresh job list
                await getJobs();

            } else {

                Swal.fire(
                    "Error",
                    res.data.message || "Unable to save recruitment",
                    "error"
                );

            }

        } catch (err) {

            console.error(err);

            Swal.fire(
                "Error",
                "Something went wrong while saving recruitment.",
                "error"
            );
        }
    };
    const generateJobCodes = () => {

        if (!form.ddchr_recruitment_deptname || !form.ddchr_recruitment_designation)
            return;

        const dept = form.ddchr_recruitment_deptname
            .substring(0, 3)
            .toUpperCase();

        const desig = form.ddchr_recruitment_designation
            .substring(0, 3)
            .toUpperCase();

        const random = Math.floor(1000 + Math.random() * 9000);

        const code = `${dept}-${desig}-${random}`;

        setForm(prev => ({
            ...prev,
            ddchr_recruitment_code: code
        }));

        // Optional, only if you're still using the separate jobcode state elsewhere
        setJobcode(code);
    };
    useEffect(() => {
        generateJobCodes();
    }, [form.ddchr_recruitment_deptname, form.ddchr_recruitment_designation]);
    useEffect(() => {

        if (isDeptChanged || isDesigChanged) {

            generateJobCodes();

        }

    }, [Departmentid, designation]);
    const qualificationOptions = [
        { value: "1", label: "SSLC" },
        { value: "2", label: "HSC" },
        { value: "3", label: "Diploma" },
        { value: "4", label: "ITI" },
        { value: "5", label: "UG Degree" },
        { value: "6", label: "PG Degree" },
        { value: "7", label: "MBA" },
        { value: "8", label: "Engineering" },
        { value: "9", label: "Any Degree" }
    ];
    // Get all department
    useEffect(() => {
        getdept();
    }, []);
    const getdept = () => {
        axios.get(baseurladdress + "getalldepts", {
            headers: {
                Authorization: `Bearer ${accesstoken}`,
            },
        })
            .then((res) => {
                console.log(res.data.response);
                setDepartments(res.data.response);
            })
            .catch((error) => {
                console.log(error);
            });
    };


    // Get all branch name
    useEffect(() => {
        getBranches();
    }, []);

    const getBranches = () => {
        axios.get(baseurladdress + "getbranchname", {
            headers: {
                Authorization: `Bearer ${accesstoken}`,
            },
        })
            .then((res) => {
                console.log(res.data.response);
                setBranches(res.data.response);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    // Get the branch address based on selecting branch

    const getBranchAddress = (branchId) => {

        axios.get(
            `${baseurladdress}getBranchAddress/${branchId}`,
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => {

                if (res.data.success) {

                    const address = res.data.data.branch_place;

                    setBranchPlace(address);

                    setForm(prev => ({
                        ...prev,
                        ddchr_recruitment_branchaddress: address
                    }));

                } else {

                    setBranchPlace("");

                    setForm(prev => ({
                        ...prev,
                        ddchr_recruitment_branchaddress: ""
                    }));

                }

            })
            .catch((err) => {
                console.log(err);
            });

    };
    //List recruitment
    useEffect(() => {

        getJobs();

    }, []);
    const getJobs = async () => {
        try {
            const res = await axios.get(
                baseurladdress + "getrecruitments",
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            setJobs(res.data.response || []);

        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {

        if (jobs.length > 0) {

            if ($.fn.DataTable.isDataTable("#jobtable")) {
                $("#jobtable").DataTable().destroy();
            }

            $("#jobtable").DataTable({
                destroy: true,
                retrieve: true
            });

        }

    }, [jobs]);
    // const getJobs = async () => {
    //     try {

    //         const res = await axios.get(
    //             baseurladdress + "getrecruitments",
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${accesstoken}`,
    //                 },
    //             }
    //         );

    //         Destroy DataTable before updating state
    //         if ($.fn.DataTable.isDataTable("#jobtable")) {
    //             $("#jobtable").DataTable().destroy();
    //         }

    //         setJobs(res.data.response || []);

    //         Reinitialize after React renders the new rows
    //         setTimeout(() => {
    //             $("#jobtable").DataTable({
    //                 destroy: true,
    //                 retrieve: true
    //             });
    //         }, 100);

    //     } catch (error) {
    //         console.error(error);
    //     }
    // };
    const getStatus = (status) => {

        switch (Number(status)) {

            case 1:
                return (
                    <span className="status-pill status-open">
                        <i className="fa fa-check-circle mr-1"></i>
                        Open
                    </span>
                );

            case 2:
                return (
                    <span className="status-pill status-closed">
                        <i className="fa fa-times-circle mr-1"></i>
                        Closed
                    </span>
                );

            case 3:
                return (
                    <span className="status-pill status-hold">
                        <i className="fa fa-pause-circle mr-1"></i>
                        On Hold
                    </span>
                );

            case 4:
                return (
                    <span className="status-pill status-draft">
                        <i className="fa fa-edit mr-1"></i>
                        Draft
                    </span>
                );

            case 5:
                return (
                    <span className="status-pill status-publish">
                        <i className="fa fa-bullhorn mr-1"></i>
                        Published
                    </span>
                );

        }

    };

    // Random code for Jobcode based on department and designation 
    const generateJobCode = (department, designation) => {

        if (!department || !designation) return "";

        const deptPrefix = department
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map(word => word.substring(0, 2))
            .join("")
            .toUpperCase();

        const desigPrefix = designation
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map(word => word.substring(0, 1))
            .join("")
            .toUpperCase();

        const random = Math.floor(1000 + Math.random() * 9000);

        return `${deptPrefix}-${desigPrefix}-${random}`;
    };


    const formatDate = (date) => {
        if (!date) return "";

        return String(date).split("T")[0];
    };
    //Edit recruitment
    const editRecruitment = async (id) => {
        try {

            const response = await axios.get(
                `${baseurladdress}editrecruitments/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            if (response.data.success) {

                const data = response.data.response[0];

                console.log("Posting Date :", data.ddchr_recruitment_postingdate);

                setForm({
                    ...initialForm,

                    ddchr_recruitment_id: data.ddchr_recruitment_id,
                    ddchr_recruitment_title: data.ddchr_recruitment_title,
                    ddchr_recruitment_designation: data.ddchr_recruitment_designation,
                    ddchr_recruitment_code: data.ddchr_recruitment_code,

                    ddchr_recruitment_workmode: String(data.ddchr_recruitment_workmode),
                    ddchr_recruitment_employmenttype: String(data.ddchr_recruitment_employmenttype),
                    ddchr_recruitment_workschedule: String(data.ddchr_recruitment_workschedule),
                    ddchr_recruitment_vaccancies: data.ddchr_recruitment_vaccancies,
                    ddchr_recruitment_priorities: data.ddchr_recruitment_priorities,

                    ddchr_recruitment_deptid: data.ddchr_recruitment_deptid,
                    ddchr_recruitment_deptname: data.ddchr_recruitment_deptname,

                    ddchr_recruitment_jointype: String(data.ddchr_recruitment_jointype),

                    ddchr_recruitment_branchid: data.ddchr_recruitment_branchid,
                    ddchr_recruitment_branchname: data.ddchr_recruitment_branchname,
                    ddchr_recruitment_branchaddress: data.ddchr_recruitment_branchaddress,

                    ddchr_recruitment_minexp: data.ddchr_recruitment_minexp,
                    ddchr_recruitment_maxexp: data.ddchr_recruitment_maxexp,
                    ddchr_recruitment_unit: String(data.ddchr_recruitment_unit),

                    ddchr_recruitment_salarytype: String(data.ddchr_recruitment_salarytype),
                    ddrchr_recruitment_minsal: data.ddchr_recruitment_minsal,
                    ddchr_recruitment_maxsal: data.ddchr_recruitment_maxsal,

                    ddchr_recruitment_incentives: data.ddchr_recruitment_incentives,
                    ddchr_recruitment_specialization: data.ddchr_recruitment_specialization,

                    ddchr_recruitment_skills: data.ddchr_recruitment_skills,
                    ddchr_recruitment_preferredskills: data.ddchr_recruitment_skills,

                    ddchr_recruitment_langknown: data.ddchr_recruitment_langknown,
                    ddchr_recruitment_certifications: data.ddchr_recruitment_certifications,

                    ddchr_recruitment_minage: data.ddchr_recruitment_minage,
                    ddchr_recruitment_maxage: data.ddchr_recruitment_maxage,
                    ddchr_recruitment_preferredcandidate: data.ddchr_recruitment_preferredcandidate,

                    ddchr_recruitment_drivingliscence: data.ddchr_recruitment_drivingliscence,
                    ddchr_recruitment_willtotravel: data.ddchr_recruitment_willtotravel,

                    ddchr_recruitment_description: data.ddchr_recruitment_description,
                    ddchr_recruitment_summary: data.ddchr_recruitment_summary,
                    ddchr_recruitment_benefits: data.ddchr_recruitment_benefits,
                    ddchr_recruitment_keywords: data.ddchr_recruitment_keywords,

                    ddchr_recruitment_postingdate: formatDate(data.ddchr_recruitment_postingdate),
                    ddchr_recruitment_closingdate: formatDate(data.ddchr_recruitment_closingdate),
                    ddchr_recruitment_lastdate: formatDate(data.ddchr_recruitment_lastdate),
                    ddchr_recruitment_expectedjoin: formatDate(data.ddchr_recruitment_expectedjoin),

                    ddchr_recruitment_status: String(data.ddchr_recruitment_status),
                    ddchr_recruitment_applicationmode: String(data.ddchr_recruitment_applicationmode),

                    ddchr_recruitment_contactperson: data.ddchr_recruitment_contactperson,
                    ddchr_recruitment_contactnumber: data.ddchr_recruitment_contactnumber,
                    ddchr_recruitment_contactemail: data.ddchr_recruitment_contactemail,
                    ddchr_recruitment_website: data.ddchr_recruitment_website,

                    ddchr_recruitment_appinstruction: data.ddchr_recruitment_appinstruction,
                    ddchr_recruitment_selectionprocess: data.ddchr_recruitment_selectionprocess,
                    ddchr_recruitment_interviewmode: data.ddchr_recruitment_interviewmode,
                    ddchr_recruitment_interviewlocation: data.ddchr_recruitment_interviewlocation,
                    ddchr_recruitment_interviewinstruction: data.ddchr_recruitment_interviewinstruction,

                    ddchr_recruitment_qualification:
                        data.ddchr_recruitment_qualification
                            ? data.ddchr_recruitment_qualification.split(",")
                            : []
                });

                seteditShowModal(true);

            }

        } catch (error) {
            console.log(error);
        }
    };
    // const editRecruitment = async (id) => {
    //     try {
    //        const token = localStorage.getItem("token");
    //        alert("iddd"+ id);
    //         const response = await axios.get(
    //             `${baseurladdress}editrecruitments/${id}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${accesstoken}`
    //                 }
    //             }
    //         );

    //         if (response.data.success) {

    //             setForm((prev) => ({
    //                 ...prev,
    //                 ddchr_recruitment_id: data.ddchr_recruitment_id
    //             }));
    //             const data = response.data.response[0];
    //             Update form state
    //             setForm(prev => ({
    //                 ...prev,
    //                 ddchr_recruitment_id: data.ddchr_recruitment_id,
    //                 ddchr_recruitment_title: data.ddchr_recruitment_title,
    //                 ddchr_recruitment_designation: data.ddchr_recruitment_designation,
    //                 ddchr_recruitment_code: data.ddchr_recruitment_code,
    //                 ddchr_recruitment_workmode: String(data.ddchr_recruitment_workmode),
    //                 ddchr_recruitment_employmenttype: String(data.ddchr_recruitment_employmenttype),
    //                 ddchr_recruitment_workschedule: String(data.ddchr_recruitment_workschedule),
    //                 ddchr_recruitment_vaccancies: data.ddchr_recruitment_vaccancies,
    //                 ddchr_recruitment_priorities: data.ddchr_recruitment_priorities,
    //                 ddchr_recruitment_deptid: data.ddchr_recruitment_deptid,
    //                 ddchr_recruitment_deptname: data.ddchr_recruitment_deptname,
    //                 ddchr_recruitment_jointype: String(data.ddchr_recruitment_jointype),
    //                 ddchr_recruitment_branchid: data.ddchr_recruitment_branchid,
    //                 ddchr_recruitment_branchname: data.ddchr_recruitment_branchname,
    //                 ddchr_recruitment_branchaddress: data.ddchr_recruitment_branchaddress,
    //                 ddchr_recruitment_minexp: data.ddchr_recruitment_minexp,
    //                 ddchr_recruitment_maxexp: data.ddchr_recruitment_maxexp,
    //                 ddchr_recruitment_unit: String(data.ddchr_recruitment_unit),
    //                 ddchr_recruitment_salarytype: String(data.ddchr_recruitment_salarytype),
    //                 ddrchr_recruitment_minsal: data.ddchr_recruitment_minsal,
    //                 ddchr_recruitment_maxsal: data.ddchr_recruitment_maxsal,
    //                 ddchr_recruitment_incentives: data.ddchr_recruitment_incentives,
    //                 ddchr_recruitment_specialization: data.ddchr_recruitment_specialization,
    //                 ddchr_recruitment_preferredskills: data.ddchr_recruitment_skills,
    //                 ddchr_recruitment_langknown: data.ddchr_recruitment_langknown,
    //                 ddchr_recruitment_certifications: data.ddchr_recruitment_certifications,
    //                 ddchr_recruitment_minage: data.ddchr_recruitment_minage,
    //                 ddchr_recruitment_maxage: data.ddchr_recruitment_maxage,
    //                 ddchr_recruitment_preferredcandidate: data.ddchr_recruitment_preferredcandidate,
    //                 ddchr_recruitment_drivingliscence: data.ddchr_recruitment_drivingliscence,
    //                 ddchr_recruitment_willtotravel: data.ddchr_recruitment_willtotravel,
    //                 ddchr_recruitment_description: data.ddchr_recruitment_description,
    //                 ddchr_recruitment_summary: data.ddchr_recruitment_summary,
    //                 ddchr_recruitment_benefits: data.ddchr_recruitment_benefits,
    //                 ddchr_recruitment_keywords: data.ddchr_recruitment_keywords,
    //                 ddchr_recruitment_postingdate: formatDate(data.ddchr_recruitment_postingdate),
    //                 ddchr_recruitment_closingdate: formatDate(data.ddchr_recruitment_closingdate),
    //                 ddchr_recruitment_lastdate: formatDate(data.ddchr_recruitment_lastdate),
    //                 ddchr_recruitment_postingdate: data.ddchr_recruitment_postingdate,
    //                 ddchr_recruitment_closingdate: data.ddchr_recruitment_closingdate,
    //                 ddchr_recruitment_lastdate: data.ddchr_recruitment_lastdate,
    //                 ddchr_recruitment_status: String(data.ddchr_recruitment_status),
    //                 ddchr_recruitment_applicationmode: String(data.ddchr_recruitment_applicationmode),
    //                 ddchr_recruitment_contactperson: data.ddchr_recruitment_contactperson,
    //                 ddchr_recruitment_contactnumber: data.ddchr_recruitment_contactnumber,
    //                 ddchr_recruitment_contactemail: data.ddchr_recruitment_contactemail,
    //                 ddchr_recruitment_website: data.ddchr_recruitment_website,
    //                 ddchr_recruitment_appinstruction: data.ddchr_recruitment_appinstruction,
    //                 ddchr_recruitment_selectionprocess: data.ddchr_recruitment_selectionprocess,
    //                 ddchr_recruitment_interviewmode: data.ddchr_recruitment_interviewmode,
    //                 ddchr_recruitment_interviewlocation: data.ddchr_recruitment_interviewlocation,
    //                ddchr_recruitment_expectedjoin: data.ddchr_recruitment_expectedjoin,
    //                 ddchr_recruitment_interviewinstruction: data.ddchr_recruitment_interviewinstruction,
    //                 ddchr_recruitment_expectedjoin: formatDate(data.ddchr_recruitment_expectedjoin),
    //                 ddchr_recruitment_qualification:
    //                     data.ddchr_recruitment_qualification
    //                         ? JSON.parse(data.ddchr_recruitment_qualification)
    //                         : ""

    //             }));
    //             alert("posting date" + data.ddchr_recruitment_postingdate);

    //             setJobTitle(data.ddchr_recruitment_title);
    //             setDepartmentid(data.ddchr_recruitment_deptid);
    //             setDepartmentname(data.ddchr_recruitment_deptname);
    //             setDesignation(data.ddchr_recruitment_designation);
    //             setJointype(data.ddchr_recruitment_jointype);
    //             setJobcode(data.ddchr_recruitment_code);
    //             setWorkmode(data.ddchr_recruitment_workmode);
    //             setEmploymenttype(data.ddchr_recruitment_employmenttype);
    //             setVaccancies(data.ddchr_recruitment_vaccancies);
    //             setWorkschedule(data.ddchr_recruitment_workschedule);
    //             setPriorities(data.ddchr_recruitment_priorities);
    //             getBranchAddress(data.ddchr_recruitment_branchid);
    //             setForm((prev) => ({
    //                 ...prev,
    //                 ddchr_recruitment_branchid: data.ddchr_recruitment_branchid,
    //                 ddchr_recruitment_branchname: data.ddchr_recruitment_branchname,
    //                 ddchr_recruitment_skills: data.ddchr_recruitment_skills,
    //                 ddchr_recruitment_langknown: data.ddchr_recruitment_langknown,
    //                 ddchr_recruitment_certifications: data.ddchr_recruitment_certifications,
    //                 ddchr_recruitment_description: data.ddchr_recruitment_description,
    //                 ddchr_recruitment_summary: data.ddchr_recruitment_summary,
    //                 ddchr_recruitment_benefits: data.ddchr_recruitment_benefits,
    //                 ddchr_recruitment_keywords: data.ddchr_recruitment_keywords,
    //             }));
    //             setLocation(data.ddchr_recruitment_branchaddress);
    //             setMinexp(data.ddchr_recruitment_minexp);
    //             setMaxexp(data.ddchr_recruitment_maxexp);
    //             setUnit(data.ddchr_recruitment_unit);
    //             setSalarytype(data.ddchr_recruitment_salarytype);
    //             setMinsal(data.ddchr_recruitment_minsal);
    //             setMaxsal(data.ddchr_recruitment_maxsal);
    //             setIncentives(data.ddchr_recruitment_incentives);
    //             setForm((prev) => ({
    //                 ...prev,
    //                 ddchr_recruitment_qualification: data.ddchr_recruitment_qualification
    //                     ? data.ddchr_recruitment_qualification.split(",")
    //                     : []
    //             }));
    //             setSpecialization(data.ddchr_recruitment_specialization);
    //             setMinage(data.ddchr_recruitment_minage);
    //             setMaxage(data.ddchr_recruitment_maxage);
    //             setPreferredcandidate(data.ddchr_recruitment_preferredcandidate);
    //             setDrivingliscence(data.ddchr_recruitment_drivingliscence);
    //             setwilltotravel(data.ddchr_recruitment_willtotravel);
    //             setDescription(data.ddchr_recruitment_description);
    //             setSummary(data.ddchr_recruitment_summary);
    //             setBenefits(data.ddchr_recruitment_benefits);
    //             setKeyword(data.ddchr_recruitment_keywords);
    //             setStatus(data.ddchr_recruitment_status);
    //             setapplicationmode(data.ddchr_recruitment_applicationmode);
    //             setcontactperson(data.ddchr_recruitment_contactperson);
    //             setcontactnumber(data.ddchr_recruitment_contactnumber);
    //             setcontactemail(data.ddchr_recruitment_contactemail);
    //             setwebsite(data.ddchr_recruitment_contactwebsite);
    //             setinstructions(data.ddchr_recruitment_appinstruction);
    //             setselectionprocess(data.ddchr_recruitment_selectionprocess);
    //             setinterviewmode(data.ddchr_recruitment_interviewmode);
    //             setintLocation(data.ddchr_recruitment_interviewlocation);
    //            setjoindate(data.ddchr_recruitment_expectedjoin);
    //             setintinstructions(data.ddchr_recruitment_interviewinstruction);
    //             if (data.ddchr_recruitment_expectedjoin) {

    //                 const joinDate = new Date(data.ddchr_recruitment_expectedjoin);

    //                 const year = joinDate.getFullYear();
    //                 const month = String(joinDate.getMonth() + 1).padStart(2, "0");
    //                 const day = String(joinDate.getDate()).padStart(2, "0");

    //                 setjoindate(`${year}-${month}-${day}`);

    //             } else {

    //                 setjoindate("");

    //             }
    //             if (data.ddchr_recruitment_postingdate) {
    //                 const date = new Date(data.ddchr_recruitment_postingdate);

    //                 const year = date.getFullYear();
    //                 const month = String(date.getMonth() + 1).padStart(2, "0");
    //                 const day = String(date.getDate()).padStart(2, "0");

    //                 setPostingdate(`${year}-${month}-${day}`);
    //             }
    //             const postingDate = data.ddchr_recruitment_postingdate
    //                 ? new Date(data.ddchr_recruitment_postingdate)
    //                 : null;

    //             const closingDate = data.ddchr_recruitment_closingdate
    //                 ? new Date(data.ddchr_recruitment_closingdate)
    //                 : null;

    //             const lastDate = data.ddchr_recruitment_lastdate
    //                 ? new Date(data.ddchr_recruitment_lastdate)
    //                 : null;

    //             console.log(postingdate);
    //             console.log(typeof postingdate);
    //             console.log(postingdate instanceof Date);
    //             const formatDate = (date) => {
    //                 const d = new Date(date);

    //                 const year = d.getFullYear();
    //                 const month = String(d.getMonth() + 1).padStart(2, "0");
    //                 const day = String(d.getDate()).padStart(2, "0");

    //                 return `${year}-${month}-${day}`;
    //             };
    //             const formatDate = (date) => {
    //                 if (!date) return "";

    //                 const d = date instanceof Date ? date : new Date(date);

    //                 if (isNaN(d.getTime())) return "";

    //                 return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    //             };

    //             setForm(prev => ({
    //                 ...prev,
    //                 ddchr_recruitment_postingdate: formatDate(postingdate),
    //                 ddchr_recruitment_closingdate: formatDate(closingDate),
    //                 ddchr_recruitment_lastdate: formatDate(lastDate),
    //             }));

    //             setForm((prev) => ({
    //                 ...prev,

    //                 ddchr_recruitment_postingdate: postingdate
    //                     ? `${postingdate.getFullYear()}-${String(postingdate.getMonth() + 1).padStart(2, "0")}-${String(postingdate.getDate()).padStart(2, "0")}`
    //                     : "",

    //                 ddchr_recruitment_closingdate: closingDate
    //                     ? `${closingDate.getFullYear()}-${String(closingDate.getMonth() + 1).padStart(2, "0")}-${String(closingDate.getDate()).padStart(2, "0")}`
    //                     : "",

    //                 ddchr_recruitment_lastdate: lastDate
    //                     ? `${lastDate.getFullYear()}-${String(lastDate.getMonth() + 1).padStart(2, "0")}-${String(lastDate.getDate()).padStart(2, "0")}`
    //                     : ""
    //             }));

    //          alert(data.ddchr_recruitment_postingdate);


    //             Open modal
    //             seteditShowModal(true);
    //         }

    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    //update recruitment
    const updateRecruitment = async (e) => {

        e.preventDefault();

        try {

            const payload = {
                ...form,
                ddchr_recruitment_qualification: Array.isArray(form.ddchr_recruitment_qualification)
                    ? form.ddchr_recruitment_qualification.join(",")
                    : form.ddchr_recruitment_qualification
            };

            console.log(payload);

            const response = await axios.post(
                `${baseurladdress}updaterecruitment/${form.ddchr_recruitment_id}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                        "Content-Type": "application/json"
                    }
                }
            );


            if (response.data.status === "success") {

                toast.success("Updated Successfully");

                seteditShowModal(false);
                setForm(initialForm);
                if (isSearching) {
                    await searchRecruitment();
                } else {
                    await getJobs();
                }
            } else {

                toast.error(response.data.message);

            }

        } catch (err) {

            console.log(err);

            if (err.response) {

                alert(err.response.data.message);

            } else {

                alert(err.message);

            }

        }

    };

    useEffect(() => {
        console.log("Jobs State:", jobs);
    }, [jobs]);
    // const searchRecruitment = async () => {
    //     setIsSearching(true);
    //     try {

    //         if ($.fn.DataTable.isDataTable("#jobtable")) {
    //             $("#jobtable").DataTable().destroy();
    //         }

    //         const response = await axios.post(
    //             `${baseurladdress}getsearchrecruitment`,
    //             {
    //                 ddchr_recruitment_branchid: search.branchId,
    //                     postingdate: search.postingDate,
    //                 closingdate: search.closingDate
    //             }
    //         );

    //         setJobs(response.data);

    //     } catch (err) {
    //         console.log(err);
    //     }

    // };

    const searchRecruitment = async () => {

        setIsSearching(true);

        try {

            if ($.fn.DataTable.isDataTable("#jobtable")) {
                $("#jobtable").DataTable().destroy();
            }

            const response = await axios.post(
                `${baseurladdress}getsearchrecruitment`,
                {
                    ddchr_recruitment_branchid: search.branchId,

                    postingDate: search.postingDate
                        ? moment(search.postingDate).format("YYYY-MM-DD")
                        : "",

                    closingDate: search.closingDate
                        ? moment(search.closingDate).format("YYYY-MM-DD")
                        : ""
                },
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            console.log(response.data);

            setJobs(response.data);

        } catch (err) {

            console.log(err);

        } finally {

            setIsSearching(false);

        }
    }; return (
        <div>
            <Topnavbar />
            <Sidennav />
            <style>{`.job-card{
    border: none;
    border-radius: 10px;
    box-shadow: 0 3px 12px rgba(0,0,0,.08);
    margin-bottom:20px;
}

.job-card-header{
    background:#f8f9fc;
    border-left:5px solid #0d6efd;
    border-bottom:1px solid #e9ecef;
    border-radius:10px 10px 0 0 !important;
    padding:15px 20px;
}

.job-card-header h5{
    font-size:18px;
    font-weight:600;
    color:#343a40;
}

.job-label{
    font-weight:600;
    color:#495057;
    margin-bottom:8px;
    display:block;
}

.job-input{
    height:45px;
    border-radius:8px;
    border:1px solid #ced4da;
    transition:.3s;
}

.job-input:focus{
    border-color:#0d6efd;
    box-shadow:0 0 0 .15rem rgba(13,110,253,.15);

.form-group {
    margin-bottom: 8px;   /* Default is around 16px */
}
}
.status-pill{
    display:inline-flex;
    align-items:center;
    padding:6px 14px;
    border-radius:25px;
    font-size:12px;
    font-weight:600;
}

.status-open{
    background:#E8F8F0;
    color:#198754;
}

.status-closed{
    background:#FDECEC;
    color:#DC3545;
}

.status-hold{
    background:#FFF8E5;
    color:#F59E0B;
}

.status-draft{
    background:#EEF1F5;
    color:#6C757D;
}

.status-publish{
    background:#E7F1FF;
    color:#0D6EFD;
}
.is-invalid {
    border: 1px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important;
}

.is-invalid-select .css-13cymwt-control,
.is-invalid-select .css-t3ipsp-control {
    border: 1px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important;
}
`}</style>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
            />
            <div className="content-wrap">
                <div className="main container-fluid">
                    <section id="main-content">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h6 className="card-title">Job Posting Details</h6>
                                <div className="d-flex align-items-center">
                                    <button
                                        type="button"
                                        className="btn plus-icon d-flex align-items-center"
                                        style={{ marginRight: "50px" }}
                                        onClick={() => setShowModal(true)}
                                    >
                                        <span style={{ fontSize: "1.2rem" }}>
                                            <i className="fa fa-plus-circle text-success"></i>
                                        </span>
                                        <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}>
                                            Add
                                        </span>
                                    </button>
                                </div>
                            </div>

                            {/* Filter Card */}
                            <div className="card mt-3 mb-3 shadow-sm">
                                <div className="card-body">
                                    <div className="row align-items-end">

                                        {/* Branch */}
                                        <div className="col-md-3">
                                            <label className="font-weight-bold">Branch</label>
                                            <Select
                                                options={brOptions}
                                                placeholder="Choose Branch"
                                                isClearable
                                                value={
                                                    brOptions.find(
                                                        option => option.value === search.branchId
                                                    ) || null
                                                }
                                                onChange={(selected) => {
                                                    setSearch((prev) => ({
                                                        ...prev,
                                                        branchId: selected ? selected.value : "",
                                                        branch_name: selected ? selected.label : ""
                                                    }));
                                                }}
                                            />
                                        </div>

                                        {/* Posting Date */}
                                        <div className="col-md-3">
                                            <label className="font-weight-bold">Posting Date</label>
                                            <input
                                                type="date"
                                                name="postingDate"
                                                className="form-control"
                                                value={search.postingDate}
                                                onChange={handleSearchChange}
                                            />
                                        </div>

                                        {/* Closing Date */}
                                        <div className="col-md-3">
                                            <label className="font-weight-bold">Closing Date</label>
                                            <input
                                                type="date"
                                                name="closingDate"
                                                className="form-control"
                                                value={search.closingDate}
                                                onChange={handleSearchChange}
                                            />
                                        </div>

                                        {/* Buttons */}
                                        <div className="col-md-3 d-flex align-items-end">
                                            <button
                                                className="btn btn-primary mr-2"
                                                onClick={searchRecruitment}
                                            >
                                                Search
                                            </button>

                                            <button
                                                className="btn btn-secondary"
                                                onClick={clearFilters}
                                            >
                                                <i className="fa fa-refresh mr-1"></i>
                                                Reset
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid">

                                <div className="card">

                                    <div className="card-header">

                                        <h5>Job Posting List</h5>

                                    </div>

                                    <div className="card-body">

                                        <table
                                            id="jobtable"
                                            className="display table table-bordered table-striped"
                                        >

                                            <thead>

                                                <tr>


                                                    <th>Job Title &Code</th>

                                                    <th>Designation & Department</th>
                                                    <th>Branch</th>
                                                    <th>Vacancies</th>

                                                    <th>Date</th>
                                                    <th>Status</th>
                                                    <th>Action</th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {

                                                    jobs.map((item, index) => (

                                                        <tr key={item.ddchr_recruitment_id}>



                                                            <td>
                                                                <div className="d-flex flex-column">
                                                                    <span className="font-weight">
                                                                        {item.ddchr_recruitment_title}
                                                                    </span>

                                                                    <small className="text-primary">
                                                                        #{item.ddchr_recruitment_code}
                                                                    </small>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="d-flex flex-column">
                                                                    <span className="font-weight">
                                                                        {item.ddchr_recruitment_designation}
                                                                    </span>

                                                                    <small className="text-muted">
                                                                        {item.ddchr_recruitment_deptname}
                                                                    </small>
                                                                </div>
                                                            </td>

                                                            <td>{item.ddchr_recruitment_branchname}</td>

                                                            <td>{item.ddchr_recruitment_vaccancies}</td>

                                                            <td>
                                                                {moment(item.ddchr_recruitment_postingdate).format("DD/MM/YYYY")}{" "}
                                                                to{" "}
                                                                {moment(item.ddchr_recruitment_closingdate).format("DD/MM/YYYY")}
                                                            </td>

                                                            <td>{getStatus(item.ddchr_recruitment_status)}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link p-0 border-0"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        console.log("Edit clicked", item.ddchr_recruitment_id);
                                                                        editRecruitment(item.ddchr_recruitment_id);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-pencil text-primary"></i>
                                                                </button>
                                                                {/*  <button
                                                                    type="button"
                                                                    className="btn btn-link p-0 border-0"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        editRecruitment(item.ddchr_recruitment_id);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-pencil text-primary"></i>
                                                                </button>*/}
                                                            </td>
                                                            {/*  <td>
                                                                <i
                                                                    className="fa fa-edit text-primary mr-3 action-icon"
                                                                    title="Edit"
                                                                    onClick={() => editRecruitment(item.ddchr_recruitment_id)}
                                                                ></i>

                                                                <i
                                                                    className="fa fa-trash text-danger action-icon"
                                                                    title="Delete"
                                                                   // onClick={() => deleteJob(item.ddchr_recruitment_id)}
                                                                ></i>
                                                            </td>*/}



                                                        </tr>

                                                    ))

                                                }

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                            </div>

                        </div>

                        {showModal && (
                            <div
                                className="modal fade show"
                                style={{
                                    display: "block",
                                    backgroundColor: "rgba(0,0,0,0.5)"
                                }}
                            >
                                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">

                                    <div className="modal-content">

                                        <div className="modal-header">
                                            <h5 className="modal-title">
                                                Job Posting Details
                                            </h5>

                                            <button
                                                type="button"
                                                className="close"
                                                onClick={() => setShowModal(false)}
                                            >
                                                <span>&times;</span>
                                            </button>
                                        </div>
                                       
}

                                        <div
                                            className="modal-body"
                                            style={{
                                                overflowY: "auto",
                                                maxHeight: "70vh"
                                            }}
                                        >

                                            <div className="card job-card">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-briefcase text-primary mr-2"></i>
                                                        Job Details
                                                    </h5>
                                                </div>
                                                <div class="card-body">
                                                    <div class="basic-form" >

                                                        <div class="form-row">

                                                            <div class="col-sm-5">
                                                                <h6>
                                                                    <span style={{ "color": "red" }}>*</span>Job Title </h6>
                                                                <input
                                                                    type="text"
                                                                    name="ddchr_recruitment_title"
                                                                    value={form.ddchr_recruitment_title}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors({
                                                                            ...errors,
                                                                            ddchr_recruitment_title: false
                                                                        });
                                                                    }}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_title ? "is-invalid" : ""
                                                                        }`}
                                                                    placeholder="Enter Job Title"
                                                                />

                                                            </div>
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Department
                                                                </h6>



                                                                <div className={errors.ddchr_recruitment_deptid ? "is-invalid-select" : ""}>
                                                                    <Select
                                                                        ref={departmentRef}
                                                                        options={departmentOptions}
                                                                        placeholder="Select Department"
                                                                        value={
                                                                            departmentOptions.find(
                                                                                option => option.value === form.ddchr_recruitment_deptid
                                                                            ) || null
                                                                        }
                                                                        onChange={(selectedOption) => {

                                                                            setForm({
                                                                                ...form,
                                                                                ddchr_recruitment_deptid: selectedOption ? selectedOption.value : "",
                                                                                ddchr_recruitment_deptname: selectedOption ? selectedOption.label : ""
                                                                            });

                                                                            setErrors((prev) => ({
                                                                                ...prev,
                                                                                ddchr_recruitment_deptid: false
                                                                            }));
                                                                        }}
                                                                        isClearable
                                                                    />
                                                                </div>

                                                                {errors.ddchr_recruitment_deptid && (
                                                                    <small className="text-danger">
                                                                        Department is required
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Designation
                                                                </h6>

                                                                <input
                                                                    ref={designationRef}
                                                                    type="text"
                                                                    name="ddchr_recruitment_designation"
                                                                    placeholder="Enter Designation"
                                                                    value={form.ddchr_recruitment_designation}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_designation ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {

                                                                        const designation = e.target.value;

                                                                        const code = generateJobCode(
                                                                            form.ddchr_recruitment_deptname,
                                                                            designation
                                                                        );

                                                                        setForm({
                                                                            ...form,
                                                                            ddchr_recruitment_designation: designation,
                                                                            ddchr_recruitment_code: code
                                                                        });

                                                                        // Remove red border when user starts typing
                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_designation: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_designation && (
                                                                    <small className="text-danger">
                                                                        Designation is required
                                                                    </small>
                                                                )}
                                                            </div>

                                                            <div class="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>Job Code</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="Enter Job Code"
                                                                    name="ddchr_recruitment_code"
                                                                    value={form.ddchr_recruitment_code}
                                                                    readOnly
                                                                //  onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Work Mode
                                                                </h6>

                                                                <select
                                                                    ref={designationRef}

                                                                    className={`form-control job-input ${errors.ddchr_recruitment_workmode ? "is-invalid" : ""
                                                                        }`}
                                                                    name="ddchr_recruitment_workmode"
                                                                    value={form.ddchr_recruitment_workmode}
                                                                    onChange={(e) => {

                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_workmode: false
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="0">Select Mode</option>
                                                                    <option value="1">Onsite</option>
                                                                    <option value="2">Remote</option>
                                                                    <option value="3">Hybrid</option>
                                                                </select>

                                                                {errors.ddchr_recruitment_workmode && (
                                                                    <small className="text-danger">
                                                                        Work Mode is required
                                                                    </small>
                                                                )}
                                                            </div>


                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Employment Type
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_employmenttype"
                                                                    value={form.ddchr_recruitment_employmenttype}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_employmenttype ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_employmenttype: false
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="0">Select Employment Type</option>
                                                                    <option value="1">Permanent</option>
                                                                    <option value="2">Probation</option>
                                                                    <option value="3">Contract</option>
                                                                    <option value="4">Temporary</option>
                                                                    <option value="5">Intern</option>
                                                                    <option value="6">Trainee</option>
                                                                    <option value="7">Part Time</option>
                                                                    <option value="8">Full Time</option>
                                                                    <option value="9">Consultant</option>
                                                                    <option value="10">Freelancer</option>
                                                                </select>

                                                                {errors.ddchr_recruitment_employmenttype && (
                                                                    <small className="text-danger">
                                                                        Employment Type is required
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Vacancies
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_vaccancies ? "is-invalid" : ""
                                                                        }`}
                                                                    placeholder="No"
                                                                    name="ddchr_recruitment_vaccancies"
                                                                    value={form.ddchr_recruitment_vaccancies}
                                                                    min="1"
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_vaccancies: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_vaccancies && (
                                                                    <small className="text-danger">
                                                                        Please enter vacancies
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Work Schedule
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_workschedule"
                                                                    value={form.ddchr_recruitment_workschedule}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_workschedule ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_workschedule: false
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="">Select Work Schedule</option>
                                                                    <option value="1">Regular Day Shift</option>
                                                                    <option value="2">Night Shift</option>
                                                                    <option value="3">Rotational Shift</option>
                                                                    <option value="4">Fixed Shift</option>
                                                                    <option value="5">Flexible Hours</option>
                                                                    <option value="6">Weekend Shift</option>
                                                                    <option value="7">Split Shift</option>
                                                                    <option value="8">24x7 Rotational</option>
                                                                    <option value="9">Monday - Friday</option>
                                                                    <option value="10">Monday - Saturday</option>
                                                                    <option value="11">Custom Schedule</option>
                                                                </select>

                                                                {errors.ddchr_recruitment_workschedule && (
                                                                    <small className="text-danger">
                                                                        Please select Work Schedule
                                                                    </small>
                                                                )}
                                                            </div>

                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Priorities </h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_priorities"
                                                                    value={form.ddchr_recruitment_priorities}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Priority</option>
                                                                    <option value="1">Low</option>
                                                                    <option value="2">Medium</option>
                                                                    <option value="3">High</option>
                                                                </select>
                                                            </div>


                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Joining Type
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_jointype"
                                                                    value={form.ddchr_recruitment_jointype}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_jointype ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_jointype: false
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="0">Select Type</option>
                                                                    <option value="1">Immediate</option>
                                                                    <option value="2">Within 7 Days</option>
                                                                    <option value="3">Within 15 Days</option>
                                                                    <option value="4">Within 30 Days</option>
                                                                    <option value="5">45 Days Notice</option>
                                                                    <option value="6">60 Days Notice</option>
                                                                    <option value="7">90 Days Notice</option>
                                                                    <option value="8">Negotiable</option>
                                                                </select>

                                                                {errors.ddchr_recruitment_jointype && (
                                                                    <small className="text-danger">
                                                                        Please select Joining Type
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Branch
                                                                </h6>

                                                                <div className={errors.ddchr_recruitment_branchid ? "is-invalid-select" : ""}>
                                                                    <Select
                                                                        ref={branchRef}
                                                                        options={branchOptions}
                                                                        placeholder="Select Branch"
                                                                        isSearchable
                                                                        isClearable
                                                                        value={
                                                                            branchOptions.find(
                                                                                option => option.value === form.ddchr_recruitment_branchid
                                                                            ) || null
                                                                        }
                                                                        onChange={(selectedOption) => {

                                                                            setForm((prev) => ({
                                                                                ...prev,
                                                                                ddchr_recruitment_branchid: selectedOption?.value || "",
                                                                                ddchr_recruitment_branchname: selectedOption?.label || ""
                                                                            }));

                                                                            setBranch(selectedOption?.value || "");

                                                                            setErrors((prev) => ({
                                                                                ...prev,
                                                                                ddchr_recruitment_branchid: false
                                                                            }));

                                                                            if (selectedOption) {
                                                                                getBranchAddress(selectedOption.value);
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>

                                                                {errors.ddchr_recruitment_branchid && (
                                                                    <small className="text-danger">
                                                                        Please select Branch
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-8 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Location
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    value={branchPlace}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            {/* ================= Experience & Salary ================= */}
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-money text-success mr-2"></i>
                                                        Experience & Salary Details
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Minimum Experience */}
                                                            <div className="col-sm-2">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span>
                                                                    Min Exp
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_minexp ? "is-invalid" : ""
                                                                        }`}
                                                                    placeholder="0"
                                                                    name="ddchr_recruitment_minexp"
                                                                    value={form.ddchr_recruitment_minexp}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_minexp: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_minexp && (
                                                                    <small className="text-danger">
                                                                        Please enter Minimum Experience
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Maximum Experience */}
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span>
                                                                    Max Exp
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_maxexp ? "is-invalid" : ""
                                                                        }`}
                                                                    placeholder="5"
                                                                    name="ddchr_recruitment_maxexp"
                                                                    value={form.ddchr_recruitment_maxexp}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_maxexp: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_maxexp && (
                                                                    <small className="text-danger">
                                                                        Please enter Maximum Experience
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Experience Unit */}
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Unit
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_unit"
                                                                    value={form.ddchr_recruitment_unit}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_unit ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_unit: false
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="0">Select</option>
                                                                    <option value="2">Years</option>
                                                                    <option value="1">Months</option>
                                                                </select>

                                                                {errors.ddchr_recruitment_unit && (
                                                                    <small className="text-danger">
                                                                        Please select Unit
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Salary Type */}
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>

                                                                    Salary Type
                                                                </h6>

                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_salarytype"
                                                                    value={form.ddchr_recruitment_salarytype}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Salary Type</option>
                                                                    <option value="1">Monthly</option>
                                                                    <option value="2">Annual (CTC)</option>
                                                                    <option value="3">Hourly</option>
                                                                    <option value="4">Daily Wage</option>
                                                                </select>
                                                            </div>

                                                            {/* Minimum Salary */}
                                                            <div className="col-sm-2">
                                                                <h6>

                                                                    Min Salary
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="15000"
                                                                    name="ddchr_recruitment_minsal"
                                                                    value={form.ddchr_recruitment_minsal}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Maximum Salary */}
                                                            <div className="col-sm-2">
                                                                <h6>

                                                                    Max Salary
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="30000"
                                                                    name="ddchr_recruitment_maxsal"
                                                                    value={form.ddchr_recruitment_maxsal}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Incentives */}

                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Benefits / Incentives</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="PF, ESI, Bonus, Medical Insurance, Incentives..."
                                                                    name="ddchr_recruitment_incentives"
                                                                    value={form.ddchr_recruitment_incentives}
                                                                    onChange={handleChange}
                                                                />

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            {/* ================= Requirements ================= */}
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-user text-info mr-2"></i>
                                                        Candidate Requirements
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Qualification */}
                                                            <div className="col-sm-4">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Qualification
                                                                </h6>

                                                                <div className={errors.ddchr_recruitment_qualification ? "is-invalid-select" : ""}>
                                                                    <Select
                                                                        ref={qualificationRef}
                                                                        options={qualificationOptions}
                                                                        isMulti
                                                                        isSearchable
                                                                        closeMenuOnSelect={false}
                                                                        placeholder="Select Qualification"
                                                                        classNamePrefix="react-select"
                                                                        value={qualificationOptions.filter(option =>
                                                                            form.ddchr_recruitment_qualification.includes(option.value)
                                                                        )}
                                                                        onChange={(selectedOptions) => {

                                                                            setForm({
                                                                                ...form,
                                                                                ddchr_recruitment_qualification: selectedOptions
                                                                                    ? selectedOptions.map(option => option.value)
                                                                                    : []
                                                                            });

                                                                            setErrors((prev) => ({
                                                                                ...prev,
                                                                                ddchr_recruitment_qualification: false
                                                                            }));
                                                                        }}
                                                                    />
                                                                </div>

                                                                {errors.ddchr_recruitment_qualification && (
                                                                    <small className="text-danger">
                                                                        Please select Qualification
                                                                    </small>
                                                                )}
                                                            </div>
                                                            {/*   <div className="col-sm-4">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Qualification
                                                                </h6>

                                                                <select className="form-control job-input"
                                                                  name="ddchr_recruitment_qualification"
                                                                value={form.ddchr_recruitment_qualification}
                                                                onChange={handleChange}
                                                                >
                                                                    <option value ="0">Select Qualification</option>
                                                                    <option value ="1">SSLC</option>
                                                                    <option value="2">HSC</option>
                                                                    <option value="3">Diploma</option>
                                                                    <option value="4">ITI</option>
                                                                    <option value="5">UG Degree</option>
                                                                    <option value="6">PG Degree</option>
                                                                    <option value="7">MBA</option>
                                                                    <option value="8">Engineering</option>
                                                                    <option value="9">Any Degree</option>
                                                                </select>
                                                            </div>*/}

                                                            {/* Specialization */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Specialization</h6>

                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="Computer Science, HR, Finance..."
                                                                    name="ddchr_recruitment_specialization"
                                                                    value={form.ddchr_recruitment_specialization}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Skills */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Required Skills
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    name="ddchr_recruitment_skills"
                                                                    placeholder="Tally, GST filing, TDS etc...."
                                                                    value={form.ddchr_recruitment_skills}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_skills ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_skills: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_skills && (
                                                                    <small className="text-danger">
                                                                        Required Skills is required
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Languages */}

                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Languages Known</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="English, Tamil, Hindi"
                                                                    name="ddchr_recruitment_langknown"
                                                                    value={form.ddchr_recruitment_langknown}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {/* Certification */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Certification</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="AWS, NPTEL, CCNA"
                                                                    name="ddchr_recruitment_certifications"
                                                                    value={form.ddchr_recruitment_certifications}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div class="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>Min Age</h6>
                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="18"
                                                                    name="ddchr_recruitment_minage"
                                                                    value={form.ddchr_recruitment_minage}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>                                                      {/* Age Limit */}

                                                            <div class="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>Max Age</h6>
                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="35"
                                                                    name="ddchr_recruitment_maxage"
                                                                    value={form.ddchr_recruitment_maxage}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>


                                                            {/* Candidate Type */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Preferred Candidate </h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_preferredcandidate"
                                                                    value={form.ddchr_recruitment_preferredcandidate}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select</option>
                                                                    <option value="1">Male</option>
                                                                    <option value="2">Female</option>
                                                                    <option value="3">Others</option>
                                                                    <option value="4">All</option>
                                                                </select>
                                                            </div>

                                                            {/* Driving License */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Driving License</h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_drivingliscence"
                                                                    value={form.ddchr_recruitment_drivingliscence}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select</option>
                                                                    <option value="1">Not Required</option>
                                                                    <option value="2">Required</option>
                                                                </select>
                                                            </div>

                                                            {/* Travel */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Willing to Travel</h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_willtotravel"
                                                                    value={form.ddchr_recruitment_willtotravel}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select</option>
                                                                    <option value="1">No</option>
                                                                    <option value="2">Yes</option>
                                                                </select>

                                                            </div>

                                                            {/* Job Description */}
                                                            <div className="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Job Description
                                                                </h6>

                                                                <textarea
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_description ? "is-invalid" : ""
                                                                        }`}
                                                                    rows="4"
                                                                    placeholder="Enter job responsibilities, description, roles and expectations..."
                                                                    name="ddchr_recruitment_description"
                                                                    value={form.ddchr_recruitment_description}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_description: false
                                                                        }));
                                                                    }}
                                                                ></textarea>

                                                                {errors.ddchr_recruitment_description && (
                                                                    <small className="text-danger">
                                                                        Job Description is required
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Job Summary
                                                                </h6>

                                                                <textarea
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_summary ? "is-invalid" : ""
                                                                        }`}
                                                                    rows="4"
                                                                    placeholder="Enter job summary..."
                                                                    name="ddchr_recruitment_summary"
                                                                    value={form.ddchr_recruitment_summary}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_summary: false
                                                                        }));
                                                                    }}
                                                                ></textarea>

                                                                {errors.ddchr_recruitment_summary && (
                                                                    <small className="text-danger">
                                                                        Job Summary is required
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Benefits</h6>
                                                                <textarea
                                                                    className="form-control job-input"
                                                                    rows="4"
                                                                    placeholder="What We Offer..."
                                                                    name="ddchr_recruitment_benefits"
                                                                    value={form.ddchr_recruitment_benefits}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>
                                                            <div className="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Keywords
                                                                </h6>

                                                                <textarea
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_keywords ? "is-invalid" : ""
                                                                        }`}
                                                                    rows="4"
                                                                    placeholder="keywords"
                                                                    name="ddchr_recruitment_keywords"
                                                                    value={form.ddchr_recruitment_keywords}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_keywords: false
                                                                        }));
                                                                    }}
                                                                ></textarea>

                                                                <small className="text-muted">
                                                                    Separate keywords with commas.
                                                                </small>

                                                                {errors.ddchr_recruitment_keywords && (
                                                                    <small className="text-danger d-block">
                                                                        Please enter Keywords
                                                                    </small>
                                                                )}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            {/* ================= Application Details ================= */}
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-file text-info mr-2"></i>
                                                        Application Details
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Job Posting Date */}
                                                            {/*  <div className="col-sm-3">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Posting Date
                                                                </h6>

                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_postingdate"
                                                                value={form.ddchr_recruitment_postingdate}
                                                                onChange={handleChange}
                                                                />
                                                            </div>*/}
                                                            <div className="col-sm-3">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Posting Date
                                                                </h6>

                                                                <input
                                                                    type="date"
                                                                    name="ddchr_recruitment_postingdate"
                                                                    value={form.ddchr_recruitment_postingdate}
                                                                    min={today}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_postingdate ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_postingdate: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_postingdate && (
                                                                    <small className="text-danger">
                                                                        Please select Posting Date
                                                                    </small>
                                                                )}
                                                            </div>
                                                            {/* close Date */}
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Closing Date
                                                                </h6>

                                                                <input
                                                                    type="date"
                                                                    name="ddchr_recruitment_closingdate"
                                                                    value={form.ddchr_recruitment_closingdate}
                                                                    min={form.ddchr_recruitment_postingdate || today}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_closingdate ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_closingdate: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_closingdate && (
                                                                    <small className="text-danger">
                                                                        Please select Closing Date
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Last Date */}
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>Last Date to Apply</h6>

                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_lastdate"
                                                                    value={form.ddchr_recruitment_lastdate}
                                                                    min={form.ddchr_recruitment_postingdate || ""}
                                                                    max={form.ddchr_recruitment_closingdate || ""}
                                                                    disabled={
                                                                        !form.ddchr_recruitment_postingdate ||
                                                                        !form.ddchr_recruitment_closingdate
                                                                    }
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {/* <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>Last Date to Apply</h6>

                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_lastdate"
                                                                value={form.ddchr_recruitment_lastdate}
                                                                onChange={handleChange}
                                                                />
                                                            </div>*/}

                                                            {/* Job Status */}
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Job Status
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_status"
                                                                    value={form.ddchr_recruitment_status}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_status ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_status: false
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="0">Select</option>
                                                                    <option value="1">Open</option>
                                                                    <option value="2">Closed</option>
                                                                    <option value="3">On Hold</option>
                                                                    <option value="4">Draft</option>
                                                                    <option value="5">Publish</option>
                                                                </select>

                                                                {errors.ddchr_recruitment_status && (
                                                                    <small className="text-danger">
                                                                        Please select Job Status
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Application Mode */}

                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Application Mode</h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_applicationmode"
                                                                    value={form.ddchr_recruitment_applicationmode}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Mode</option>
                                                                    <option value="1">Online</option>
                                                                    <option value="2">Walk-In</option>
                                                                    <option value="3">Email</option>
                                                                    <option value="4">Referral</option>
                                                                </select>
                                                            </div>
                                                            {/* Contact Person */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Contact Person
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    name="ddchr_recruitment_contactperson"
                                                                    placeholder="HR Name"
                                                                    value={form.ddchr_recruitment_contactperson}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_contactperson ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_contactperson: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_contactperson && (
                                                                    <small className="text-danger">
                                                                        Please enter Contact Person
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Contact Number */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Contact Number
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    name="ddchr_recruitment_contactnumber"
                                                                    placeholder="9876543210"
                                                                    maxLength="10"
                                                                    value={form.ddchr_recruitment_contactnumber}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_contactnumber ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {

                                                                        // Allow only numbers
                                                                        const value = e.target.value.replace(/\D/g, "");

                                                                        setForm({
                                                                            ...form,
                                                                            ddchr_recruitment_contactnumber: value
                                                                        });

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_contactnumber: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_contactnumber && (
                                                                    <small className="text-danger">
                                                                        Enter a valid 10-digit mobile number
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Email */}
                                                            <div className="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Application Email
                                                                </h6>

                                                                <input
                                                                    type="email"
                                                                    name="ddchr_recruitment_contactemail"
                                                                    placeholder="hr@company.com"
                                                                    value={form.ddchr_recruitment_contactemail}
                                                                    className={`form-control job-input ${errors.ddchr_recruitment_contactemail ? "is-invalid" : ""
                                                                        }`}
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_contactemail: false
                                                                        }));
                                                                    }}
                                                                />

                                                                {errors.ddchr_recruitment_contactemail && (
                                                                    <small className="text-danger">
                                                                        Please enter a valid email address
                                                                    </small>
                                                                )}
                                                            </div>

                                                            {/* Website */}
                                                            <div class="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>Application Website</h6>
                                                                <input
                                                                    type="url"
                                                                    className="form-control job-input"
                                                                    placeholder="https://company.com/careers"
                                                                    name="ddchr_recruitment_contactwebsite"
                                                                    value={form.ddchr_recruitment_contactwebsite}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Additional Instructions */}
                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Application Instructions</h6>
                                                                <textarea
                                                                    rows="3"
                                                                    className="form-control job-input"
                                                                    placeholder="Mention documents required, interview process, application instructions..."
                                                                    name="ddchr_recruitment_appinstruction"
                                                                    value={form.ddchr_recruitment_appinstruction}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-tasks text-primary mr-2"></i>
                                                        Selection Process
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Selection Process */}
                                                            <div className="col-md-6">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span>
                                                                    Selection Process
                                                                </h6>

                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_selectionprocess"
                                                                    value={form.ddchr_recruitment_selectionprocess}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Process</option>
                                                                    <option value="1">Resume Screening</option>
                                                                    <option value="2">HR Interview</option>
                                                                    <option value="3">Technical Interview</option>
                                                                    <option value="4">Aptitude Test</option>
                                                                    <option value="5">Written Test</option>
                                                                    <option value="6">Coding Test</option>
                                                                    <option value="7">Assignment</option>
                                                                    <option value="8">Group Discussion</option>
                                                                    <option value="9">Managerial Interview</option>
                                                                    <option value="10">Final Interview</option>
                                                                    <option value="11">Document Verification</option>
                                                                    <option value="12">Background Verification</option>
                                                                    <option value="13">Medical Examination</option>
                                                                    <option value="14">Direct Selection</option>
                                                                </select>
                                                            </div>

                                                            {/* Interview Mode */}
                                                            <div className="col-md-6 mt-3 mt-md-0">
                                                                <h6>Interview Mode</h6>

                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_interviewmode"
                                                                    value={form.ddchr_recruitment_interviewmode}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Interview Mode</option>
                                                                    <option value="1">Walk-in</option>
                                                                    <option value="2">Face-to-Face</option>
                                                                    <option value="3">Telephone</option>
                                                                    <option value="4">Video Call</option>
                                                                    <option value="5">Online</option>
                                                                    <option value="6">Hybrid</option>
                                                                </select>
                                                            </div>

                                                            {/* Interview Location */}
                                                            <div class="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>Interview Location</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="Enter Interview Address"
                                                                    name="ddchr_recruitment_interviewlocation"
                                                                    value={form.ddchr_recruitment_interviewlocation}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>


                                                            {/* Expected Joining */}
                                                            <div class="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>Expected Joining</h6>
                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_expectedjoin"
                                                                    value={form.ddchr_recruitment_expectedjoin}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Additional Instructions */}
                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Interview Instructions</h6>
                                                                <textarea
                                                                    className="form-control job-input"
                                                                    rows="3"
                                                                    placeholder="Carry updated resume, ID proof, original certificates, etc."
                                                                    name="ddchr_recruitment_interviewinstruction"
                                                                    value={form.ddchr_recruitment_interviewinstruction}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="modal-footer">

                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => setShowModal(false)}
                                            >
                                                Close
                                            </button>

                                            <button
                                                className="btn btn-primary"
                                                onClick={handleSubmit}
                                            >
                                                Save
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Edit Job recruitment*/}
                        {editshowModal && (
                            <div
                                className="modal fade show"
                                style={{
                                    display: "block",
                                    backgroundColor: "rgba(0,0,0,0.5)"
                                }}
                            >
                                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">

                                    <div className="modal-content">

                                        <div className="modal-header">
                                            <h5 className="modal-title">
                                                Edit Job Posting Details
                                            </h5>

                                            <button
                                                type="button"
                                                className="close"
                                                onClick={() => seteditShowModal(false)}
                                            >
                                                <span>&times;</span>
                                            </button>
                                        </div>
                                       
}

                                        <div
                                            className="modal-body"
                                            style={{
                                                overflowY: "auto",
                                                maxHeight: "70vh"
                                            }}
                                        >

                                            <div className="card job-card">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-briefcase text-primary mr-2"></i>
                                                        Job Details
                                                    </h5>
                                                </div>
                                                <div class="card-body">
                                                    <div class="basic-form" >

                                                        <div class="form-row">

                                                            <div class="col-sm-4">
                                                                <h6>
                                                                    <span style={{ "color": "red" }}>*</span>Job Title </h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_title"
                                                                    value={form.ddchr_recruitment_title || ""}
                                                                    onChange={handleChange}
                                                                />

                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Department
                                                                </h6>



                                                                <div className={errors.ddchr_recruitment_deptid ? "is-invalid-select" : ""}>
                                                                    <Select
                                                                        options={departmentOptions}
                                                                        value={
                                                                            departmentOptions.find(
                                                                                option => String(option.value) === String(form.ddchr_recruitment_deptid)
                                                                            ) || null
                                                                        }
                                                                        onChange={(selectedOption) => {

                                                                            setForm(prev => ({
                                                                                ...prev,
                                                                                ddchr_recruitment_deptid: selectedOption.value,
                                                                                ddchr_recruitment_deptname: selectedOption.label
                                                                            }));

                                                                            setDepartmentid(selectedOption.value);
                                                                            setDepartmentname(selectedOption.label);

                                                                            setIsDeptChanged(true);
                                                                        }}
                                                                    />
                                                                </div>


                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Designation
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="ddchr_recruitment_designation"
                                                                    value={form.ddchr_recruitment_designation || ""}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        setIsDesigChanged(true);
                                                                    }}
                                                                />

                                                            </div>
                                                            <div class="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>Job Code</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="Enter Job Code"
                                                                    name="ddchr_recruitment_code"
                                                                    value={form.ddchr_recruitment_code || ""}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Work Mode
                                                                </h6>

                                                                <select
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_workmode"
                                                                    value={form.ddchr_recruitment_workmode || "0"}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="0">Select Mode</option>
                                                                    <option value="1">Onsite</option>
                                                                    <option value="2">Remote</option>
                                                                    <option value="3">Hybrid</option>
                                                                </select>


                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Employment Type
                                                                </h6>

                                                                <select
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_employmenttype"
                                                                    value={form.ddchr_recruitment_employmenttype || "0"}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="0">Select Employment Type</option>
                                                                    <option value="1">Permanent</option>
                                                                    <option value="2">Probation</option>
                                                                    <option value="3">Contract</option>
                                                                    <option value="4">Temporary</option>
                                                                    <option value="5">Intern</option>
                                                                    <option value="6">Trainee</option>
                                                                    <option value="7">Part Time</option>
                                                                    <option value="8">Full Time</option>
                                                                    <option value="9">Consultant</option>
                                                                    <option value="10">Freelancer</option>
                                                                </select>

                                                            </div>
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Vacancies
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="No"
                                                                    name="ddchr_recruitment_vaccancies"
                                                                    value={form.ddchr_recruitment_vaccancies || ""}
                                                                    min="1"
                                                                    onChange={handleChange}
                                                                />


                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Work Schedule
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_workschedule"
                                                                    className="form-control job-input"
                                                                    value={form.ddchr_recruitment_workschedule || ""}
                                                                    onChange={handleChange}

                                                                >
                                                                    <option value="">Select Work Schedule</option>
                                                                    <option value="1">Regular Day Shift</option>
                                                                    <option value="2">Night Shift</option>
                                                                    <option value="3">Rotational Shift</option>
                                                                    <option value="4">Fixed Shift</option>
                                                                    <option value="5">Flexible Hours</option>
                                                                    <option value="6">Weekend Shift</option>
                                                                    <option value="7">Split Shift</option>
                                                                    <option value="8">24x7 Rotational</option>
                                                                    <option value="9">Monday - Friday</option>
                                                                    <option value="10">Monday - Saturday</option>
                                                                    <option value="11">Custom Schedule</option>
                                                                </select>

                                                                {errors.ddchr_recruitment_workschedule && (
                                                                    <small className="text-danger">
                                                                        Please select Work Schedule
                                                                    </small>
                                                                )}
                                                            </div>

                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Priorities </h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_priorities"
                                                                    value={form.ddchr_recruitment_priorities || "0"}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="0">Select Priority</option>
                                                                    <option value="1">Low</option>
                                                                    <option value="2">Medium</option>
                                                                    <option value="3">High</option>
                                                                </select>
                                                            </div>


                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Joining Type
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_jointype"
                                                                    value={form.ddchr_recruitment_jointype || "0"}
                                                                    className="form-control job-input"
                                                                    onChange={handleChange}
                                                                >

                                                                    <option value="0">Select Type</option>
                                                                    <option value="1">Immediate</option>
                                                                    <option value="2">Within 7 Days</option>
                                                                    <option value="3">Within 15 Days</option>
                                                                    <option value="4">Within 30 Days</option>
                                                                    <option value="5">45 Days Notice</option>
                                                                    <option value="6">60 Days Notice</option>
                                                                    <option value="7">90 Days Notice</option>
                                                                    <option value="8">Negotiable</option>
                                                                </select>


                                                            </div>
                                                            <div className="col-sm-4 mt-2 mt-sm-0">

                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Branch
                                                                </h6>
                                                                <Select
                                                                    options={branchOptions}
                                                                    placeholder="Select Branch"
                                                                    value={
                                                                        branchOptions.find(
                                                                            option =>
                                                                                String(option.value) ===
                                                                                String(form.ddchr_recruitment_branchid)
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) => {

                                                                        setForm(prev => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_branchid: selectedOption?.value || "",
                                                                            ddchr_recruitment_branchname: selectedOption?.label || ""
                                                                        }));

                                                                        if (selectedOption) {
                                                                            getBranchAddress(selectedOption.value);
                                                                        } else {
                                                                            setLocation("");

                                                                            setForm(prev => ({
                                                                                ...prev,
                                                                                ddchr_recruitment_branchaddress: ""
                                                                            }));
                                                                        }
                                                                    }}
                                                                />

                                                            </div>
                                                            <div className="col-sm-8 mt-2 mt-sm-0">

                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Location
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    value={form.ddchr_recruitment_branchaddress || ""}
                                                                    onChange={handleChange}
                                                                    readOnly
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            {/* ================= Experience & Salary ================= */}
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-money text-success mr-2"></i>
                                                        Experience & Salary Details
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Minimum Experience */}
                                                            <div className="col-sm-2">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span>
                                                                    Min Exp
                                                                </h6>
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control job-input"
                                                                    placeholder="0"
                                                                    name="ddchr_recruitment_minexp"
                                                                    value={form.ddchr_recruitment_minexp || ""}
                                                                    onChange={handleChange}
                                                                />

                                                            </div>

                                                            {/* Maximum Experience */}
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span>
                                                                    Max Exp
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control job-input"
                                                                    placeholder="0"
                                                                    name="ddchr_recruitment_maxexp"
                                                                    value={form.ddchr_recruitment_maxexp || ""}
                                                                    onChange={handleChange}
                                                                />


                                                            </div>

                                                            {/* Experience Unit */}
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Unit
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_unit"
                                                                    value={form.ddchr_recruitment_unit || "0"}
                                                                    className="form-control job-input"
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="0">Select</option>
                                                                    <option value="2">Years</option>
                                                                    <option value="1">Months</option>
                                                                </select>


                                                            </div>

                                                            {/* Salary Type */}
                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>

                                                                    Salary Type
                                                                </h6>

                                                                <select className="form-control job-input"

                                                                    name="ddchr_recruitment_salarytype"
                                                                    value={form.ddchr_recruitment_salarytype || "0"}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Salary Type</option>
                                                                    <option value="1">Monthly</option>
                                                                    <option value="2">Annual (CTC)</option>
                                                                    <option value="3">Hourly</option>
                                                                    <option value="4">Daily Wage</option>
                                                                </select>
                                                            </div>

                                                            {/* Minimum Salary */}
                                                            <div className="col-sm-2">
                                                                <h6>

                                                                    Min Salary
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="15000"
                                                                    name="ddchr_recruitment_minsal"

                                                                    value={form.ddchr_recruitment_minsal || ""}

                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Maximum Salary */}
                                                            <div className="col-sm-2">
                                                                <h6>

                                                                    Max Salary
                                                                </h6>

                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="30000"
                                                                    name="ddchr_recruitment_maxsal"
                                                                    value={form.ddchr_recruitment_maxsal || ""}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Incentives */}

                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Benefits / Incentives</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_incentives"
                                                                    value={form.ddchr_recruitment_incentives || ""}
                                                                    onChange={handleChange}
                                                                />

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            {/* ================= Requirements ================= */}
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-user text-info mr-2"></i>
                                                        Candidate Requirements
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Qualification */}
                                                            <div className="col-sm-4">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Qualification
                                                                </h6>

                                                                <div className={errors.ddchr_recruitment_qualification ? "is-invalid-select" : ""}>
                                                                    <Select
                                                                        options={qualificationOptions}
                                                                        isMulti
                                                                        value={qualificationOptions.filter(option =>
                                                                            form.ddchr_recruitment_qualification.includes(option.value)
                                                                        )}
                                                                        onChange={(selectedOptions) => {
                                                                            setForm(prev => ({
                                                                                ...prev,
                                                                                ddchr_recruitment_qualification: selectedOptions
                                                                                    ? selectedOptions.map(option => option.value).join(",")
                                                                                    : ""
                                                                            }));
                                                                        }}
                                                                    />
                                                                </div>


                                                            </div>

                                                            {/* Specialization */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Specialization</h6>

                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="Computer Science, HR, Finance..."
                                                                    name="ddchr_recruitment_specialization"
                                                                    value={form.ddchr_recruitment_specialization}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Skills */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Required Skills
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    name="ddchr_recruitment_skills"

                                                                    value={form.ddchr_recruitment_skills}
                                                                    className="form-control job-input"
                                                                    onChange={(e) => {
                                                                        handleChange(e);

                                                                        setErrors((prev) => ({
                                                                            ...prev,
                                                                            ddchr_recruitment_skills: false
                                                                        }));
                                                                    }}
                                                                />


                                                            </div>

                                                            {/* Languages */}

                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Languages Known</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="English, Tamil, Hindi"
                                                                    name="ddchr_recruitment_langknown"
                                                                    value={form.ddchr_recruitment_langknown}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {/* Certification */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Certification</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="AWS, NPTEL, CCNA"
                                                                    name="ddchr_recruitment_certifications"
                                                                    value={form.ddchr_recruitment_certifications}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div class="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>Min Age</h6>
                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"
                                                                    placeholder="18"
                                                                    name="ddchr_recruitment_minage"
                                                                    value={form.ddchr_recruitment_minage}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>                                                      {/* Age Limit */}

                                                            <div class="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>Max Age</h6>
                                                                <input
                                                                    type="number"
                                                                    className="form-control job-input"

                                                                    name="ddchr_recruitment_maxage"
                                                                    value={form.ddchr_recruitment_maxage}
                                                                    onChange={handleChange}

                                                                />
                                                            </div>


                                                            {/* Candidate Type */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Preferred Candidate </h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_preferredcandidate"
                                                                    value={form.ddchr_recruitment_preferredcandidate}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select</option>
                                                                    <option value="1">Male</option>
                                                                    <option value="2">Female</option>
                                                                    <option value="3">Others</option>
                                                                    <option value="4">All</option>
                                                                </select>
                                                            </div>

                                                            {/* Driving License */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Driving License</h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_drivingliscence"
                                                                    value={form.ddchr_recruitment_drivingliscence}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select</option>
                                                                    <option value="1">Not Required</option>
                                                                    <option value="2">Required</option>
                                                                </select>
                                                            </div>

                                                            {/* Travel */}
                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Willing to Travel</h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_willtotravel"
                                                                    value={form.ddchr_recruitment_willtotravel}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select</option>
                                                                    <option value="1">No</option>
                                                                    <option value="2">Yes</option>
                                                                </select>

                                                            </div>

                                                            {/* Job Description */}
                                                            <div className="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Job Description
                                                                </h6>

                                                                <textarea
                                                                    className="form-control job-input"
                                                                    rows="4"
                                                                    name="ddchr_recruitment_description"
                                                                    value={form.ddchr_recruitment_description}
                                                                    onChange={handleChange}                                                                ></textarea>


                                                            </div>
                                                            <div className="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Job Summary
                                                                </h6>

                                                                <textarea
                                                                    className="form-control job-input"
                                                                    rows="4"

                                                                    name="ddchr_recruitment_summary"
                                                                    value={form.ddchr_recruitment_summary}
                                                                    onChange={handleChange}                                                                ></textarea>

                                                            </div>
                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Benefits</h6>
                                                                <textarea
                                                                    className="form-control job-input"
                                                                    rows="4"

                                                                    name="ddchr_recruitment_benefits"
                                                                    value={form.ddchr_recruitment_benefits}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>
                                                            <div className="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Keywords
                                                                </h6>

                                                                <textarea
                                                                    className="form-control job-input"
                                                                    rows="4"

                                                                    name="ddchr_recruitment_keywords"
                                                                    value={form.ddchr_recruitment_keywords}
                                                                    onChange={handleChange}
                                                                ></textarea>

                                                                <small className="text-muted">
                                                                    Separate keywords with commas.
                                                                </small>


                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            {/* ================= Application Details ================= */}
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-file text-info mr-2"></i>
                                                        Application Details
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Job Posting Date */}

                                                            <div className="col-sm-3">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Posting Date
                                                                </h6>

                                                                <input
                                                                    type="date"
                                                                    name="ddchr_recruitment_postingdate"
                                                                    value={form.ddchr_recruitment_postingdate}

                                                                    className="form-control job-input"
                                                                    onChange={handleChange}
                                                                />

                                                            </div>
                                                            {/* close Date */}
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Closing Date
                                                                </h6>

                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_closingdate"
                                                                    value={form.ddchr_recruitment_closingdate}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Last Date */}
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>Last Date to Apply</h6>

                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_lastdate"
                                                                    value={form.ddchr_recruitment_lastdate}
                                                                    min={form.ddchr_recruitment_postingdate || ""}
                                                                    max={form.ddchr_recruitment_closingdate || ""}
                                                                    disabled={
                                                                        !form.ddchr_recruitment_postingdate ||
                                                                        !form.ddchr_recruitment_closingdate
                                                                    }
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {/* <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>Last Date to Apply</h6>

                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_lastdate"
                                                                value={form.ddchr_recruitment_lastdate}
                                                                onChange={handleChange}
                                                                />
                                                            </div>*/}

                                                            {/* Job Status */}
                                                            <div className="col-sm-3 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Job Status
                                                                </h6>

                                                                <select
                                                                    name="ddchr_recruitment_status"
                                                                    value={form.ddchr_recruitment_status}
                                                                    className="form-control job-input"
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="0">Select</option>
                                                                    <option value="1">Open</option>
                                                                    <option value="2">Closed</option>
                                                                    <option value="3">On Hold</option>
                                                                    <option value="4">Draft</option>
                                                                    <option value="5">Publish</option>
                                                                </select>

                                                            </div>

                                                            {/* Application Mode */}

                                                            <div class="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>Application Mode</h6>
                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_applicationmode"
                                                                    value={form.ddchr_recruitment_applicationmode}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Mode</option>
                                                                    <option value="1">Online</option>
                                                                    <option value="2">Walk-In</option>
                                                                    <option value="3">Email</option>
                                                                    <option value="4">Referral</option>
                                                                </select>
                                                            </div>
                                                            {/* Contact Person */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Contact Person
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    name="ddchr_recruitment_contactperson"

                                                                    value={form.ddchr_recruitment_contactperson}
                                                                    className="form-control job-input"
                                                                    onChange={handleChange}
                                                                />


                                                            </div>

                                                            {/* Contact Number */}
                                                            <div className="col-sm-4 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Contact Number
                                                                </h6>

                                                                <input
                                                                    type="text"
                                                                    name="ddchr_recruitment_contactnumber"

                                                                    maxLength="10"
                                                                    value={form.ddchr_recruitment_contactnumber}

                                                                    className="form-control job-input"
                                                                    onChange={handleChange}
                                                                />


                                                            </div>

                                                            {/* Email */}
                                                            <div className="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>
                                                                    <span style={{ color: "red" }}>*</span> Application Email
                                                                </h6>

                                                                <input
                                                                    type="email"
                                                                    name="ddchr_recruitment_contactemail"

                                                                    value={form.ddchr_recruitment_contactemail}
                                                                    className="form-control job-input"
                                                                    onChange={handleChange}
                                                                />


                                                            </div>

                                                            {/* Website */}
                                                            <div class="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>Application Website</h6>
                                                                <input
                                                                    type="url"
                                                                    className="form-control job-input"

                                                                    name="ddchr_recruitment_contactwebsite"
                                                                    value={form.ddchr_recruitment_contactwebsite}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Additional Instructions */}
                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Application Instructions</h6>
                                                                <textarea
                                                                    rows="3"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_appinstruction"
                                                                    value={form.ddchr_recruitment_appinstruction}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="card job-card mt-3">

                                                <div className="card-header job-card-header">
                                                    <h5 className="mb-0">
                                                        <i className="fa fa-tasks text-primary mr-2"></i>
                                                        Selection Process
                                                    </h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="basic-form">

                                                        <div className="form-row">

                                                            {/* Selection Process */}
                                                            <div className="col-md-6">
                                                                <h6>

                                                                    Selection Process
                                                                </h6>

                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_selectionprocess"
                                                                    value={form.ddchr_recruitment_selectionprocess}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Process</option>
                                                                    <option value="1">Resume Screening</option>
                                                                    <option value="2">HR Interview</option>
                                                                    <option value="3">Technical Interview</option>
                                                                    <option value="4">Aptitude Test</option>
                                                                    <option value="5">Written Test</option>
                                                                    <option value="6">Coding Test</option>
                                                                    <option value="7">Assignment</option>
                                                                    <option value="8">Group Discussion</option>
                                                                    <option value="9">Managerial Interview</option>
                                                                    <option value="10">Final Interview</option>
                                                                    <option value="11">Document Verification</option>
                                                                    <option value="12">Background Verification</option>
                                                                    <option value="13">Medical Examination</option>
                                                                    <option value="14">Direct Selection</option>
                                                                </select>
                                                            </div>

                                                            {/* Interview Mode */}
                                                            <div className="col-md-6 mt-3 mt-md-0">
                                                                <h6>Interview Mode</h6>

                                                                <select className="form-control job-input"
                                                                    name="ddchr_recruitment_interviewmode"
                                                                    value={form.ddchr_recruitment_interviewmode}
                                                                    onChange={handleChange}>
                                                                    <option value="0">Select Interview Mode</option>
                                                                    <option value="1">Walk-in</option>
                                                                    <option value="2">Face-to-Face</option>
                                                                    <option value="3">Telephone</option>
                                                                    <option value="4">Video Call</option>
                                                                    <option value="5">Online</option>
                                                                    <option value="6">Hybrid</option>
                                                                </select>
                                                            </div>

                                                            {/* Interview Location */}
                                                            <div class="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>Interview Location</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control job-input"
                                                                    placeholder="Enter Interview Address"
                                                                    name="ddchr_recruitment_interviewlocation"
                                                                    value={form.ddchr_recruitment_interviewlocation}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>


                                                            {/* Expected Joining */}
                                                            <div class="col-sm-6 mt-2 mt-sm-0">
                                                                <h6>Expected Joining</h6>
                                                                <input
                                                                    type="date"
                                                                    className="form-control job-input"
                                                                    name="ddchr_recruitment_expectedjoin"
                                                                    value={form.ddchr_recruitment_expectedjoin}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            {/* Additional Instructions */}
                                                            <div class="col-sm-12 mt-2 mt-sm-0">
                                                                <h6>Interview Instructions</h6>
                                                                <textarea
                                                                    className="form-control job-input"
                                                                    rows="3"
                                                                    name="ddchr_recruitment_interviewinstruction"
                                                                    value={form.ddchr_recruitment_interviewinstruction}
                                                                    onChange={handleChange}
                                                                ></textarea>
                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="modal-footer">

                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => seteditShowModal(false)}
                                            >
                                                Close
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={updateRecruitment}
                                            >
                                                Update
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Jobpost;
